import * as DemoAction from './demo.actions';
import {Demo} from '../demo.model';
import * as fromProfile from '../../profile/store/profile.reducers';

export interface State extends fromProfile.State {
  auditList: Demo[];
}

const initialState: State = {...{
  auditList: []
  },
  ...fromProfile.initialState
};

export function demoReducer(state = initialState, action: DemoAction.DemoActions) {
  switch (action.type) {
    case DemoAction.SET_DEMO_LIST:
      return {
        ...state,
        auditList: action.payload
      };
    case DemoAction.SET_CHARTS_RELOAD:
      return {
        ...state,
        chartReload: action.payload
      };
    case DemoAction.SET_AUDIT:
      return {
        ...state,
        audit: action.payload
      };
    case DemoAction.SET_AUDIENCE_STAT:
      return {
        ...state,
        audienceStat: action.payload
      };
    case DemoAction.SET_FOLLOWER_STAT:
      return {
        ...state,
        followerStat: action.payload
      };
    case DemoAction.SET_MEDIA_STAT:
      return {
        ...state,
        mediaStat: action.payload
      };
    case DemoAction.SET_AUDIENCE_INTEREST:
      return {
        ...state,
        audienceInterest: action.payload
      };
    case DemoAction.SET_AUDIENCE_LOCATION:
      return {
        ...state,
        audienceLocation: action.payload
      };
    case DemoAction.SET_MEDIA_ANALYZE:
      return {
        ...state,
        mediaAnalyze: action.payload
      };
    case DemoAction.SET_MEDIA_COMMENT_ANALYZE:
      return {
        ...state,
        mediaCommentAnalyze: action.payload
      };
    case DemoAction.SET_PROFILE_DETAIL:
      return {
        ...state,
        profileDetail: action.payload
      };
    case DemoAction.SET_PROFILE_PROGRESS:
      return {
        ...state,
        profileProgress: action.payload
      };
    case DemoAction.SET_FOLLOWER_ENGAGE:
      return {
        ...state,
        followerEngage: action.payload
      };
    case DemoAction.SET_FOLLOWER_ENGAGE_INDICATOR:
      return {
        ...state,
        followerEngageIndicator: action.payload
      };
    case DemoAction.SET_LOADER:
      const loader = state.loader;
      loader[action.payload.module][action.payload.box] = action.payload.value;
      return {
        ...state,
        loader: loader
      };
    case DemoAction.SET_AUTOLOAD:
      return {
        ...state,
        autoload: action.payload
      };
    case DemoAction.SET_PROFILE_MEDIA:
      return {
        ...state,
        profileMedia: action.payload
      };
    case DemoAction.SET_PROFILE_SCORE:
      return {
        ...state,
        score: action.payload
      };
  }
  return state;
}
